import { render, staticRenderFns } from "./accountRecovery.vue?vue&type=template&id=50bb85e6&scoped=true&"
import script from "./accountRecovery.vue?vue&type=script&lang=js&"
export * from "./accountRecovery.vue?vue&type=script&lang=js&"
import style0 from "./accountRecovery.vue?vue&type=style&index=0&id=50bb85e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb85e6",
  null
  
)

export default component.exports